import styled from 'styled-components';

import { borderRadius } from '~/design-tokens/border-radius/borderRadius';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const MarkdownStyles = styled.div`
  ${typographyV2.bodyBase};
  margin-bottom: 16px;
  overflow: auto;

  h1 {
    ${typographyV2.titleLg}
  }

  h2 {
    ${typographyV2.titleMd}
  }

  h3 {
    ${typographyV2.titleBase}
  }

  h4 {
    ${typographyV2.titleBase};
  }

  h5 {
    ${typographyV2.titleSm};
  }

  p {
    margin-bottom: 1em;
  }

  code:not(pre code) {
    padding: 4px;
    color: var(--text-primary);
    background-color: var(--surface-default);
    ${borderRadius.r05};
  }

  ul {
    list-style-type: disc;
    margin: 1em 0;
    padding: 0 0 0 2em;
  }
`;
